export default __webpack_public_path__ + "assets/icons/mark_question_solid.892f589a.svg";